var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Jepaas-detail-orderList background-F5F5F5"},[_c('el-backtop'),_c('div',{staticClass:"box_top"},[_c('Header')],1),_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }